import React from 'react';
import './CourseCards.css';

const CourseCards: React.FC = () => {
  const courses = [
    {
      title: "Matura Podstawowa",
      description: "Solidne przygotowanie do matury na poziomie podstawowym. Wszystkie typy zadan i techniki rozwiazywania.",
      icon: "basic",
      tag: "Popularny"
    },
    {
      title: "Matura Rozszerzona",
      description: "Intensywny kurs dla ambitnych maturzystow. Zaawansowane zagadnienia i strategie egzaminacyjne.",
      icon: "advanced",
      tag: "Bestseller"
    },
    {
      title: "Egzamin Osmoklasisty",
      description: "Kompleksowe przygotowanie do egzaminu. Budowanie pewnosci siebie i solidnych podstaw.",
      icon: "exam",
      tag: null
    },
    {
      title: "Konkursy i Olimpiady",
      description: "Trening dla przyszlych laureatow. Zaawansowane techniki i niestandardowe zadania.",
      icon: "trophy",
      tag: "Elite"
    },
    {
      title: "Szkola Podstawowa",
      description: "Budowanie solidnych fundamentow matematycznych. Nauka przez zabaw i praktyczne zastosowania.",
      icon: "school",
      tag: null
    },
    {
      title: "Nadrabianie Zaleglosci",
      description: "Szybkie uzupelnienie brakow w wiedzy. Spersonalizowany plan dopasowany do Twoich potrzeb.",
      icon: "catch-up",
      tag: null
    }
  ];

  const getIcon = (type: string) => {
    switch (type) {
      case 'basic':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
          </svg>
        );
      case 'advanced':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        );
      case 'exam':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <polyline points="10 9 9 9 8 9" />
          </svg>
        );
      case 'trophy':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 9H4.5a2.5 2.5 0 010-5H6" />
            <path d="M18 9h1.5a2.5 2.5 0 000-5H18" />
            <path d="M4 22h16" />
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
            <path d="M18 2H6v7a6 6 0 0012 0V2z" />
          </svg>
        );
      case 'school':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
            <path d="M6 12v5c3 3 9 3 12 0v-5" />
          </svg>
        );
      case 'catch-up':
        return (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
            <polyline points="17 6 23 6 23 12" />
          </svg>
        );
      default:
        return null;
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="courses" className="awesome-courses-section">
      <div className="awesome-courses-container">
        <div className="awesome-courses-header">
          <h2 className="awesome-courses-title">Nasze kursy</h2>
          <p className="awesome-courses-subtitle">
            Kompleksowe wsparcie w nauce matematyki na kazdym poziomie
          </p>
        </div>

        <div className="awesome-courses-grid">
          {courses.map((course, index) => (
            <div key={index} className="awesome-course-card" onClick={scrollToContact}>
              {course.tag && (
                <span className="awesome-course-tag">{course.tag}</span>
              )}
              <div className="awesome-course-icon">
                {getIcon(course.icon)}
              </div>
              <h3 className="awesome-course-title">{course.title}</h3>
              <p className="awesome-course-description">{course.description}</p>
              <span className="awesome-course-link">
                Dowiedz sie wiecej
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseCards;
